/* eslint-disable max-len */
import { spiderTypes } from '../types/spider.types';

const initialState = {
  brands: {
    data: [],
    loading: false
  },
  models: {
    data: [],
    loading: false
  },
  channels: {
    data: [],
    loading: false
  }
};

const spiderReducer = (state = initialState, action) => {
  switch (action.type) {
    case spiderTypes.GET_MARCAS:
      return {
        ...state,
        brands: {
          ...state.brands,
          loading: true
        }
      };
    case spiderTypes.GET_MARCAS_SUCCESS:
      return {
        ...state,
        brands: {
          data: action.payload,
          loading: false
        }
      };
    case spiderTypes.GET_MARCAS_FAILED:
      return {
        ...state,
        brands: {
          ...initialState.brands,
          error: action.error
        }
      };
    case spiderTypes.GET_MODELOS:
      return {
        ...state,
        models: {
          ...state.brands,
          loading: true
        }
      };
    case spiderTypes.GET_MODELOS_SUCCESS:
      return {
        ...state,
        models: {
          data: action.payload,
          loading: false
        }
      };
    case spiderTypes.GET_MODELOS_FAILED:
      return {
        ...state,
        models: {
          ...initialState.models,
          error: action.error
        }
      };
    case spiderTypes.GET_CHANNEL_REQUEST:
      return {
        ...state,
        channels: {
          ...state.channels,
          loading: true
        }
      };
    case spiderTypes.GET_CHANNEL_SUCCESS:
      return {
        ...state,
        channels: {
          data: action.payload,
          loading: false
        }
      };
    case spiderTypes.GET_CHANNEL_FAILED:
      return {
        ...state,
        channels: {
          ...initialState.channels,
          error: action.error
        }
      };
    default:
      return state;
  }
};

export default spiderReducer;